var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDragLine1 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1701240349459,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 15879,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M771.669333 252.928a42.666667 42.666667 0 0 1 0 60.330667L313.088 771.84a42.666667 42.666667 0 0 1-60.416-60.330667l458.581333-458.581333a42.666667 42.666667 0 0 1 60.416 0z m4.778667 306.346667a42.666667 42.666667 0 0 1 0 60.330666L619.605333 776.448a42.666667 42.666667 0 1 1-60.330666-60.330667l156.842666-156.842666a42.666667 42.666667 0 0 1 60.330667 0z",
    fill: "#A6A6A6",
    "p-id": 15880
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDragLine1);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/drag_line1.f3e140e4c226fbe5d31fdd0b47c7831a.svg";